// ============================================================
// state.js — All mutable game state
// ============================================================
// Every global `let` variable from index.html lives here.
// Import this object and mutate its properties in place so that
// every module shares the same live references.
// ============================================================

export const state = {
  // --- Badges / Character Selection ---
  badges: { tomni: false, wangle: false, booble: false, max: false, maghata: false, zinger: false },
  selectedCharacter: 'tomni',
  selectedChar: 'zinger',
  caineUnlocked: false,
  secretUnlocked: false,   // ELCHICOQUESEPARECEMUCHOATOMNI — escape w/ everyone incl. Waine
  charSelectFromWin: false,

  // --- Core Settings ---
  sfxEnabled: true,
  musicSource: 'mp3',   // 'mp3' | 'og'
  musicVolume: 1,       // 0–1
  paused: false,
  escaped: false,
  inMenu: true,

  // --- Score / Combo ---
  score: 0,
  combo: 0,
  comboTimer: null,

  // --- Audio State ---
  audioCtx: null,
  musicPlaying: false,
  musicNodes: [],
  darkMusicPlaying: false,
  ogMusicPlaying: false,
  voidMusicPlaying: false,
  voidMusicNodes: [],
  phase5MusicPlaying: false,
  phase5MusicNodes: [],

  // --- Shop: Click Power ---
  clickPower: 1,
  clickPowerLevel: 0,
  clickPowerCost: 50,

  // --- Shop: Auto Clicker ---
  autoClickerCount: 0,
  autoClickerCost: 250,
  autoClickerIntervals: [],
  autoMouseElements: [],

  // --- Shop: Auto Speed ---
  autoSpeedLevel: 0,
  autoSpeedCost: 500,

  // --- Shop: Mega Click ---
  megaClickLevel: 0,
  megaClickCost: 1000,

  // --- Phase Flags ---
  bombMode: false,
  frozenMode: false,
  phase3Active: false,
  phase4Active: false,
  phase5Active: false,

  // --- Eye Boss (12000+ clicks) ---
  eyeBossActive: false,
  eyeBossTriggered: false,   // once per session
  eyeBossAnimFrame: null,
  eyeBossDefeatTimer: null,

  // --- Hazards: Fire ---
  fireInterval: null,

  // --- Hazards: Frozen / Lightning / Icebergs ---
  lightningInterval: null,
  iceInterval: null,
  icebergInterval: null,
  icebergAnimFrame: null,
  icebergs: [],

  // --- Hazards: Bombs ---
  bombs: [],
  bombInterval: null,
  bombAnimFrame: null,

  // --- Hazards: Abstraction (Phase 3) ---
  originalPlushieSrc: '',
  absOrbInterval: null,
  absGlitchInterval: null,
  absAttackInterval: null,
  absGlitchHazardInterval: null,
  absLaserInterval: null,
  absShockwaveInterval: null,
  absGlitchBombInterval: null,
  absGlitchBombs: [],
  absGlitchBombFrame: null,

  // --- Plushie Movement / Glitch (Phase 3) ---
  plushieMoveInterval: null,
  plushieGlitchInterval: null,

  // --- Death / Game-Over ---
  dead: false,

  // --- Mouse Position ---
  mouseX: 0,
  mouseY: 0,

  // --- Pause / Countdown ---
  countdownActive: false,
  awaitingFirstClick: false,   // true after continue-from-menu, unfrozen on first plushie click

  // --- Competitive Mode ---
  gameMode: 'normal',
  lives: 3,
  highScore: parseInt(localStorage.getItem('smoothClicker_highScore') || '0'),

  // --- Shields (Competitive) ---
  shieldInterval: null,
  activeShields: [],
  shieldFirstTime: true,

  // --- Loading Screen ---
  loadProgress: 0,

  // --- Online / Auth ---
  supabaseUser: null,
  userProfile: null,
  onlineMode: false,
  sessionLog: null,
};
